import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportTypes/${number | ':fieldReportTypeId'}/segment`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportTypes/:fieldReportTypeId/segment`;

export const URL = (fieldReportId: number, fieldReportTypeId: number): RouteDefinition => `${baseRoute}/${fieldReportId}/fieldReportTypes/${fieldReportTypeId}/segment`;
